import store from '@/store';
import baseRoute from './baseRoute';
import ManagePage from '@/views/ManagePage.vue';
import CoursesPage from '@/views/manage/CoursesPage.vue';
import UsersPage from '@/views/manage/UsersPage.vue';
import GroupsPage from '@/views/manage/GroupsPage.vue';
import EditCoursePage from '@/views/manage/EditCoursePage.vue';
import ViewCoursePage from '@/views/manage/ViewCoursePage.vue';
import GroupCoursesPage from '@/views/manage/GroupCoursesPage.vue';
import GroupUsersPage from '@/views/manage/GroupUsersPage.vue';
import SettingsPage from '@/views/manage/SettingsPage.vue';
import rolesGuard from './guards/rolesGuard';

export default (guards = null) =>
  baseRoute(
    {
      path: '/manage',
      component: ManagePage,
      children: [
        {
          path: '',
          redirect: redirectWithRoles,
          meta: {
            title: 'Zarządzanie'
          }
        },
        {
          path: 'courses',
          component: CoursesPage,
          beforeEnter: rolesGuard('CourseAdmin'),
          meta: {
            title: 'Szkolenia',
            breadcrumbs: [
              {
                text: 'Szkolenia'
              }
            ]
          }
        },
        {
          path: 'courses/edit/:id',
          component: EditCoursePage,
          beforeEnter: rolesGuard('CourseAdmin'),
          meta: {
            title: 'Edycja szkolenia {course}',
            breadcrumbs: [
              {
                text: 'Szkolenia',
                to: '/manage/courses'
              },
              {
                text: 'Edycja szkolenia {course}'
              }
            ]
          }
        },
        {
          path: 'courses/view/:id',
          component: ViewCoursePage,
          beforeEnter: rolesGuard('CourseAdmin'),
          meta: {
            title: 'Podgląd szkolenia {course}',
            breadcrumbs: [
              {
                text: 'Szkolenia',
                to: '/manage/courses'
              },
              {
                text: 'Podgląd szkolenia {course}'
              }
            ]
          }
        },
        {
          path: 'users',
          component: UsersPage,
          beforeEnter: rolesGuard('Admin'),
          meta: {
            title: 'Użytkownicy',
            breadcrumbs: [
              {
                text: 'Użytkownicy'
              }
            ]
          }
        },
        {
          path: 'groups',
          component: GroupsPage,
          beforeEnter: rolesGuard('Teacher'),
          meta: {
            title: 'Grupy',
            breadcrumbs: [
              {
                text: 'Grupy'
              }
            ]
          }
        },
        {
          path: 'groups/:groupId/courses',
          component: GroupCoursesPage,
          beforeEnter: rolesGuard('Teacher'),
          meta: {
            title: 'Przypisane szkolenia grupy {group}',
            breadcrumbs: [
              {
                text: 'Grupy',
                to: '/manage/groups'
              },
              {
                text: 'Przypisane szkolenia grupy {group}'
              }
            ]
          }
        },
        {
          path: 'groups/:groupId/users',
          component: GroupUsersPage,
          beforeEnter: rolesGuard('Teacher'),
          meta: {
            title: 'Przypisani użytkownicy grupy {group}',
            breadcrumbs: [
              {
                text: 'Grupy',
                to: '/manage/groups'
              },
              {
                text: 'Przypisani użytkownicy grupy {group}'
              }
            ]
          }
        },
        {
          path: 'settings',
          component: SettingsPage,
          beforeEnter: rolesGuard('Admin'),
          meta: {
            title: 'Ustawienia',
            breadcrumbs: [
              {
                text: 'Ustawienia'
              }
            ]
          }
        },
        {
          path: '*',
          redirect: 'courses'
        }
      ]
    },
    guards
  );

function redirectWithRoles() {
  if (store.getters['account/canViewManagePanel']) {
    if (store.getters['account/permissions'].includes('Lms_Administration_Courses')) {
      return '/manage/courses';
    } else if (store.getters['account/permissions'].includes('Pages_Users')) {
      return '/manage/users';
    } else if (store.getters['account/permissions'].includes('Lms_Administration_ManagesGroups')) {
      return '/manage/groups';
    }
  }

  return '/';
}
